export default "__VITE_ASSET__BKq1xM21__"